'use strict';

import Alpine from 'shared/js/alpinejs';
// TODO - remove this file entirely

